// export const CONTIGO_API_URL = "http://localhost:5000/"
export const CONTIGO_API_URL = process.env.REACT_APP_API_URL
